import { render, staticRenderFns } from "./PriceAreaTheme0.vue?vue&type=template&id=fa39ca40&scoped=true"
import script from "./PriceAreaTheme0.vue?vue&type=script&lang=js"
export * from "./PriceAreaTheme0.vue?vue&type=script&lang=js"
import style0 from "./PriceAreaTheme0.vue?vue&type=style&index=0&id=fa39ca40&prod&scoped=true&lang=css"
import style1 from "./PriceAreaTheme0.vue?vue&type=style&index=1&id=fa39ca40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa39ca40",
  null
  
)

export default component.exports